import React, { useEffect, useState } from "react";
import "../../css/Profile/Profile.css";
import MessageSender from "../MessageSender";
import db from "../../firebase";

// import Post from "../Post";
import { useStateValue } from "../../StateProvider";
import ProfileHeader from "./ProfileHeader";
import ProfileSide from "./ProfileSide";

import { useParams } from "react-router-dom";
import Feed from "../Feed";

function Profile() {
  const [{ user, userProfile }] = useStateValue();
  let { username } = useParams();

  const [profile, setProfile] = useState({});

  useEffect(() => {
    // Create a reference to the cities collection
    var usersRef = db.collection("users");

    // Create a query against the collection.
    var query = usersRef.where("username", "==", username);

    query
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          //   console.log(doc.id, " => ", doc.data());
          setProfile(doc.data());
          //   console.log(profile);
        });
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);
      });
  }, [username]);

  return (
    <div className="profile">
      <ProfileHeader profile={profile} />
      <div className="profile__container">
        <div className="profile__side">
          <ProfileSide />
        </div>
        <div className="profile__main">
          <MessageSender />
          <Feed isProfile username={username} />
        </div>
      </div>
    </div>
  );
}

export default Profile;
